<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="closeMenuPanel" v-if="isPanelOpen"> </div>
        <transition name="slide">
            <div v-if="isPanelOpen" class="sidebar-panel">
                <div class="navbar-brand">
                    Curriculum Vitae
                </div>
                <ul class="sidebar-panel-nav">
                    <li>
                        <a href="#" class="ripple"><font-awesome-icon class="icon" icon="home"/>Home</a>
                    </li>
                    <li>
                        <a href="#" class="ripple"><font-awesome-icon  class="icon" icon="user"/>About</a>
                    </li>
                    <li>
                        <a href="#" class="ripple"><font-awesome-icon class="icon" icon="paper-plane"/>Contact</a>
                    </li>
                    <li>
                        <a href="https://emilsprojects.site" target="_blank" class="ripple">
                            <font-awesome-icon class="icon" icon="folder-open"/>
                            Portfolio
                        </a>
                    </li>
                </ul>
                <div class="form-group">
                    <label for="search"></label>
                    <input type="text" class="form-control" placeholder="Search" id="search" name="search">
                </div>
                <div class="credit">
                    <p>developed by:</p>
                    <h5>Luchian Emil</h5>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import { store, mutations } from '../../store.js'

    export default {
        name: "Menu",
        methods: {
            closeMenuPanel: mutations.toggleNav
        },
        computed: {
            isPanelOpen() {
                return store.isNavOpen
            }
        }
    }
</script>
<style>
    .slide-enter-active,
    .slide-leave-active
    {
        transition: transform 0.4s ease;
    }
    .slide-enter,
    .slide-leave-to {
        transform: translateX(100%);
        transition: all 350ms ease-in 0s
    }

    .sidebar-backdrop {
        background-color: rgba(19, 15, 64, .6);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
    }

    .sidebar-panel {
        overflow-y: auto;
        background-image: url("../../assets/mountains.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        position: fixed;
        right: 0;
        top: 0;
        height: 100vh;
        z-index: 999;
        padding: 10px 0;
        width: 230px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }
    .sidebar-panel::after{
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: .6;
        z-index: -1;
        background: linear-gradient(135deg, rgba(47,137,252,1) 0%, rgba(94,255,201,1) 100%);
    }
    .navbar-brand {
        /*padding-top: 30px;*/
        font-weight: 700;
        color: navy;
        text-shadow: 2px 2px 8px blue;
        font-size: 25px;
        margin: 0;
    }

    ul.sidebar-panel-nav {
        /*padding-top: 30px;*/
        padding-left: 0;
        width: 100%;
        list-style-type: none;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    li {
        width: 100%;
    }
    .icon {
        margin-right: 15px;
    }
    ul.sidebar-panel-nav > li > a {
        color: white;
        text-decoration: none;
        font-size: 1rem;
        display: block;
        padding: 15px 25px;
        border-bottom: 2px solid rgba(168, 202, 255, 0.1);

    }

    .credit {
        color: lightblue;
        font-size: 16px;
        text-shadow: none;

    }
    .credit>h5 {
        color: navy;
        font-size: 25px;
        text-shadow: 0 0 5px white;
        text-align: center;
        font-weight: 700;
    }
</style>
